import { TemplateRef } from '@angular/core';
import { InternalNavigationTriggerModel } from '../navigation/internalNavigationTrigger.model';
import { ConfirmData } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { Observable } from 'rxjs';
import { ActionGetAgentStepSensitiveDataResponseModel } from 'src/app/services/httpServices/detection/aiAgentStepsHttpService/ai-agent-steps-http.service';

export interface ICardField {
  key: string;
  customTemplate?: TemplateRef<unknown>;
  value?: string | null;
  valueLink?: string | null;
  additionalValues?: string[];
  method?: () => void;
  isCopyable?: boolean;
  copyableText?: string;
  tooltipLabelPath?: string;
  tooltipIconPath?: string;
  iconPath?: string;
  isChipStyle?: boolean; // When true, applies chip/badge styling to the field value
  descriptionLabelPath?: string;
  internalNavigation?: InternalNavigationTriggerModel;
  dictSeverity?: Record<string, number>;
  isRawValue?: boolean;
  confirmedData?: ConfirmData;
  showPopupBtn?: boolean;
  sensitiveBtnText?: string;
  sensitiveDataMethod?: () => Observable<ActionGetAgentStepSensitiveDataResponseModel>;
  /** When true, prevents toggle-content (See More/Less) regardless of overflow */
  disableToggle?: boolean;
  hideValue?: boolean; // When true, hides the value/copyableText text but keeps the copy button functional
}

export enum CardFieldKey {
  ConversationStarters = 'Conversation Starters',
  ResourceDescription = 'Resource Description',
  Instructions = 'Instructions',
  WebBrowsingCapability = 'Web Browsing Capability',
}
